import styled from "styled-components";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { screen } from "../BreakPoints";
import { FontStyle } from "../FontStyle";

export const StyledDialog = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-height: calc(100vh - 156px);
  background-color: var(--page-paper-main);
  color: var(--color-theme-900);
  box-shadow: var(--shadow-primary);
  border-radius: 8px;
  width: 310px;
  margin: 60px auto 30px auto;
  position: relative;

  ${FontStyle}
  ${BoxSizingStyle}

  ${screen.sm} {
    width: 540px;
    margin: 126px auto 30px auto;
  }
`;

StyledDialog.displayName = "StyledDialog";

export const StyledDialogTitle = styled.div`
  padding: 20px 30px;

  ${FontStyle}
  ${BoxSizingStyle}
`;
StyledDialogTitle.displayName = "StyledDialogTitle";

export const StyledDialogContent = styled.div`
  padding: 20px 30px;
  max-height: 580px;
  overflow-y: auto;
  flex: 1 1 auto;

  ${FontStyle}
  ${BoxSizingStyle}
`;
StyledDialogContent.displayName = "StyledDialogContent";

export const StyledDialogContentDivider = styled.div`
  border-top: 1px solid var(--border-primary);
  height: 1px;
`;
StyledDialogContentDivider.displayName = "StyledDialogContentDivider";

export const StyledDialogActions = styled.div`
  padding: 20px 30px;

  ${FontStyle}
  ${BoxSizingStyle}
`;
StyledDialogActions.displayName = "StyledDialogActions";
